import { css } from '@emotion/core';

export const myProfileMenuHeaderCSS = ({ colors }) => css`
    display: flex;
    flex-direction: row;

    img {
        height: 2.5rem;
        margin: 0 0.5rem 0 0;
        border-radius: 2.5rem;
    }

    > div {
        display: flex;
        gap: 0.25rem;
        flex-direction: column;
        height: 100%;

        > div:last-child {
            color: ${colors.textSecondary};
            word-wrap: break-word;
        }
    }
`;

export const myProfileMenuHeaderClassOverridesCSS = css`
    cursor: default;
`;

export const userMenuOverrideCSS = css`
    padding: 0.5rem 0;
`;

export const userMenuItemCSS = css`
    padding: 0.75rem 1rem;
`;

export const userMenuItemLinkCSS = ({ colors }) => css`
    a {
        width: 100%;
        color: ${colors.black};
        padding: 0.75rem 1rem;
    }
`;

export const userMenuSystemAccessIsLoggedCSS = ({ colors }) => css`
    color: ${colors.textSecondary};
`;

export const userMenuItemBlockCSS = () => css`
    display: inline;
`;

export const userMenuSystemAccessIsLoggedMenuItemCSS = ({ colors }) => css`
    ${userMenuItemLinkCSS({ colors })};
    color: ${colors.black};
    cursor: pointer;
    text-decoration: none;
`;

export const userMenuLogoutButtonCSS = ({ colors }) => css`
    all: unset;
    width: 100%;
    padding: 1rem;
    ${userMenuItemLinkCSS({ colors })};
    color: ${colors.black};
    cursor: pointer;
    text-decoration: none;
`;
